import "./App.css";
import Header from "./components/header/Header";
import HeroSection from "./pages/home/HeroSection";
import StatsSection from "./pages/home/StatsSection";
import svg1 from "../src/assets/images/stats/svg/percent.svg";
import svg2 from "../src/assets/images/stats/svg/rupee.svg";
import svg3 from "../src/assets/images/stats/svg/happy.svg";
import svg4 from "../src/assets/images/stats/svg/location.svg";
import TheMagicSection from "./pages/home/TheMagicSection";
import FAQsSection from "./pages/home/FAQs";
import WhatMakes from "./pages/home/WhatMakes";
import PlanComparison from "./pages/home/PlanComparison";
import PlanComparisonMobile from "./pages/home/mobile-responsive/PlanComparisonMobile";
import Blogs from "./pages/home/Blogs";
import VideoCarousel from "./pages/home/VideoCarousel";
import HealthInsurance from "./pages/home/HealthInsurance";
import HealthInsuranceMobile from "./pages/home/mobile-responsive/HealthInsuranceMobile";
import OurHealth from "./pages/home/OurHealth";
import WhatMakesMobile from "./pages/home/mobile-responsive/WhatMakesMobile";
import VideoCarouselMobile from "./pages/home/mobile-responsive/VideoCarouselMobile";
import Footer from "./components/footer/Footer";
import BackdropComponent from "./components/BackdropComponent";
import { useSelector } from "react-redux";

function App() {
  const sendOtpData = useSelector((state) => state.sarvah.sendOtp);
  const verifyOtpData = useSelector((state) => state.sarvah.verifyOtp);
  const submitFormData = useSelector((state) => state.sarvah.submitForm);

  const {
    status: sendOtpDataStatus,
    data: sendOtpDataDetails,
    error: sendOtpDataError,
  } = sendOtpData;
  const {
    status: verifyOtpDataStatus,
    data: verifyOtpDataDetails,
    error: verifyOtpDataError,
  } = verifyOtpData;
  const {
    status: submitFormDataStatus,
    data: submitFormDataDetails,
    error: submitFormDataError,
  } = submitFormData;
  const statsData = [
    {
      icon: svg1,
      alt: "percent",
      value: "Up to 40%",
      description: "Discount including 5% Online Booking Discount",
    },
    {
      icon: svg2,
      alt: "rupee",
      value: "5,770.73 Cr",
      description: "Worth Claim settled",
    },
    { icon: svg3, alt: "happy", value: "15 Mn+", description: "Active Lives" },
    {
      icon: svg4,
      alt: "location",
      value: "35000+",
      description: "OPD Cashless Network",
    },
  ];

  return (
    <div className="">
      {verifyOtpDataStatus === "pending" ? <BackdropComponent /> : null}
      {sendOtpDataStatus === "pending" ? <BackdropComponent /> : null}
      {submitFormDataStatus === "pending" ? <BackdropComponent /> : null}

      <Header />
      <HeroSection />
      <StatsSection stats={statsData} />
      <TheMagicSection />
      <WhatMakes />
      <WhatMakesMobile />
      <HealthInsurance link="#heroSectionForm" />
      <HealthInsuranceMobile link="#heroSectionForm" />
      <PlanComparison />
      <PlanComparisonMobile />
      <Blogs />
      {/* <VideoCarousel /> */}
      {/* <VideoCarouselMobile /> */}
      <OurHealth />
      <FAQsSection />
      <Footer />
    </div>
  );
}

export default App;
